import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountLoanListPageUI from './AccountLoanListPageUI.js'

class AccountLoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
      createLoanMode: false,
    }
  }

  render() {
    return (
      <AccountLoanListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        createLoanMode={this.state.createLoanMode}
        onCreateLoanClick={() => { this.setState({ 'createLoanMode': true }) }}
        onCancelCreateLoan={() => { this.setState({ 'createLoanMode': false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getLoans(context)
  }

  getLoans(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/loans`,
      cacheKey: CacheKeys.AccountLoans(this.props.match.params.accountId),
      callback: this.getLoansCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AccountLoans(this.props.match.params.accountId))
    this.setState({ loanList: null, errorList: null },
      this.getLoans(this.props.context)
    )
  }
}

export default withRouter(AccountLoanListPageSF)